import { memo } from "react";
import { Filters, useFeatureFiltersContext } from "ui/widgets/Filters";
import useAddMerchantPaymentMethodModel from "./useAddMerchantPaymentMethodModel";
import { Collection } from "ui/support/Resource";

const AddMerchantPaymentMethodFilters = () => {
    const { filters, onChange } = useFeatureFiltersContext();
    const { getFilterOptions } = useAddMerchantPaymentMethodModel();

    return (
        <Collection
            sx={{
                mx: 2,
                display: 'grid',
                placeContent: 'center',
                gap: 2
            }}
            collection={filters}
            renderResource={filter => (
                <Filters
                    key={filter.props.id}
                    {...filter}
                    props={{
                        ...filter.props,
                        ...getFilterOptions(filter.props.id)
                    }}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default memo(AddMerchantPaymentMethodFilters);
